import React from "react";
import './css/firstchoice_about.css';
import * as CONFIG from './_config'

const FirstchoiceAbout = () => {

    return (

        <>
      <h3 className="title">
        Welcome {CONFIG.DATA.BACKEND_HOST === 'prengerfoods' ? "Home" : ""} to {" "} {CONFIG.DATA.RSA_CLIENT_APP_NAME}
        </h3>
                             
            <div class="grid-flex">
                <div class="col col-image" style={{
                    background: `url("/assets/images/about/firstchoice_abt1.png")`
                }}

                >
                    &nbsp;
                </div>
                <div class="col col-text col-left">
                    <div class="Aligner-item">
                        <p>FIrst Choice Market opened in Walsenburg on February  3rd 2011. Since that time, we’ve grown into the store of Choice for Huerfano County residents and others who live in neighboring communities.
                            Our focus on excellence has fueled our favored status and has given us a reputation to live up to everyday.
                            Trip Advisor awarded us ‘The Best of The Best Award” and we’re very proud of it!
                            When competitors struggled to maintain stocked shelves, we kept our community well stocked and well fed. Being locally owned and operated has the benefit of our full attention to the needs of our community every day!
                            We believe in community involvement and supporting one another starting at the local level. We invested in the people of Huerfano county and support the community in many ways throughout the year. We donate to the local food bank, support kids' programs such as 4-H and Christmas giving to the local churches for family assistance annually.
                            Our family-owned store offers a convenient one-stop shop where you can find everything you need from the everyday essentials to specialty items. We are the only full-service Super Market in Huerfano County providing a bakery, deli, stone oven pizzeria as well as sporting goods, camping needs, and services like U-HAUL, UPS and Western Union to name a few.
                            Our friendly staff are here to help you find exactly what you’re looking for and are always eager to find new items that are sure to please your palate.
                            We take pride in our community and appreciate your patronage, working hard each day to continue to earn your business
                            with high-quality foods, friendly service, and great prices.
                        </p>
                    </div>
                </div>
            </div>


            <div class="grid-flex">
                <div class="col col-image" style={{ background: `url("/assets/images/about/firstchoice_abt2.png")` }}>
                    &nbsp;
                </div>

                <div class="col col-text">
                    <div class="Aligner-item">
                        <p>Stanton County Foods and Syracuse Food Center have served Western Kansas for three decades, we are committed to the way of life we all share in rural America.  We are your “HOMETOWN” source for your family's needs.  We believe in community involvement and supporting one another.
                            We are your local community connection for high-quality foods, friendly service, and great prices.
                            Our family-owned stores offer a convenient one-stop shop where you can find everything you need from the everyday essentials to specialty items.
                            Our friendly staff are here to help you find exactly what you’re looking for and are always eager to find new items that are sure to please your palate.
                            We take pride in our community and appreciate your business, working hard each day to continue to earn your business.
                            Hugh and Denise Brown purchased the store in Johnson in 1993 and Syracuse in 1995. Brent and Heather Hinrichs have been an intracule part of our Kansas operations and have managed the Stores for decades. Their presence in the stores has provided stability and consistency for the communities and are proud to be your HOMETOWN grocers.
                        </p>
                    </div>
                </div>
            </div>

            <div className="section-bg style-1" style={{padding: '40px'}}>
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-lg-6" style={{padding: '0px'}}>
                                <img loading="lazy" alt={CONFIG.DATA.STORE_IMAGE_ALT_TEXT} src={CONFIG.DATA.STORE_IMAGE} style={{/* maxHeight: 411, objectFit: 'cover'*/}} className='img-response'/>
                            </div>
                        
                            <div className="about_us wpb_column vc_column_container vc_col-sm-12 vc_col-lg-6 vc_col-md-12">
                                <div className="vc_column-inner">
                                    <div className="wpb_wrapper">
                                        <div className="widget widget-features-box  ">
                                            <div className="content">
                                                <div className="feature-box-inner clearfix">
                                                    <div className="fbox-icon">
                                                        <i className="fa fa-heart"></i>
                                                    </div>
                                                    <div className="fbox-content ">
                                                    {CONFIG.DATA.BACKEND_HOST === "grocerydepotms" ?
                             
                                                        <h3 className="ourservice-heading"> Great Shopping Experience</h3>
                                                        :
                                                        <h3 className="ourservice-heading"> Great Shopping Experience</h3>
                            
                                                        // <h3 className="ourservice-heading"> 100% Customer Satisfaction</h3>
                                                     
                                                            
                                                            }
                                                      
                                                        <div className="description">To give our customers the best quality products and services at competitive prices in pleasant and safe conditions</div>
                                                    </div>
                                                </div>
                                                <div className="feature-box-inner clearfix">
                                                    <div className="fbox-icon">
                                                        <i className="fa fa-gift"></i>
                                                    </div>
                                                    <div className="fbox-content ">
                                                        <h3 className="ourservice-heading">Enjoyable Work Environment</h3>
                                                        <div className="description">To provide our associates and employees a safe and enjoyable work environment while providing competitive wage and benefit compensation.</div>  
                                                    </div> 
                                                </div>
                                                <div className="feature-box-inner clearfix">
                                                    <div className="fbox-icon">
                                                        <i className="fa fa-group"></i>
                                                    </div>
                                                    <div className="fbox-content ">
                                                        <h3 className="ourservice-heading">Community Projects</h3>
                                                        <div className="description">Our stores participate in our local Chambers of Commerce and our managers are members of local clubs and organizations.</div>  
                                                    </div> 
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

        </>
    )
}

export default FirstchoiceAbout
